export default {
  'footer.tos': '服务条款',
  'footer.privacy': '隐私政策'
};
